const ApiTags = {
  STUDENT_HOMEWORK_SUMMARY: 'StudentHomeworkSummary'
};

export default ApiTags;
